module.exports = __webpack_public_path__ + "static/media/angle-arrow-down-primary-hover.935c8699.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/angle-arrow-down-primary-hover.svg
// module id = 165
// module chunks = 0